const InitialPrice = {
  min: 0,
  max: 100,
};

const InitialStops = [
  { value: "nonstop", label: "Direct", minprice: 0 },
  { value: "1stop", label: "1 Stop", minprice: 0 },
  // { value: "2stop", label: "1 + Stops", minprice: 0 },
];
const InitialFlights = {
  data: [],
  iataAirlineCodes: [],
  id: "",
  oneWay: "",
};

const CABIN_OPTIONS = [
  { value: 4, label: "Economy" },
  { value: 2, label: "Business" },
  { value: 3, label: "Premium Economy" },
  { value: 1, label: "First" },
];

const InitialFilters = {
  price: { min: 0, max: 100 },
  stops: ["1stop", "nonstop", "2stop"],
  time: { inbound: { max: 24, min: 0 }, outbound: { max: 24, min: 0 } },
  airlines: [],
  halts: [],
  cabin: CABIN_OPTIONS[0].value,
};

const InitialAirlineName = [{ name: "", iata: "", minprice: 0 }];

const TIMINGS = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
  "23:59",
];

const NAMES = [
  "William",
  "James",
  "Harper",
  "Ella",
  "Jackson",
  "Isabella",
  "Ava",
  "Freya",
  "Alice",
  "Rosie",
  "Elizabeth",
  "Jasmine",
  "Emilia",
  "Martha",
  "Maria",
];

const CABINS = {
  1: "First",
  2: "Business",
  3: "Premium Economy",
  4: "Economy",
};

const HALT_DURATIONS = {
  short: {
    label: "Short Connection",
    sublabel: "(0 - 2 hours)",
    range: [0, 2.25],
  },
  relaxed: {
    label: "Relaxed Connection",
    sublabel: "(2 - 4 hours)",
    range: [1.75, 4.25],
  },
  long: {
    label: "Long Connection",
    sublabel: "(4 - 8 hours)",
    range: [3.75, 8],
  },
  longer: {
    label: "Longer Connection",
    sublabel: "(8+ hours)",
    range: [8],
  },
};

const DEFAULT_UK_ORIGIN = "London - LHR";
const USA_CURRENCY = "USD";
const UK_CURRENCY = "GBP";
const EU_CURRENCY = "EUR";

const OPTIONAL_FIELDS = [
  "seat_preference",
  "meal_preference",
  "frequent_flyer_programme",
  "frequent_flyer_number",
  "assistance",
];

const SEAT_PREFERENCE = [
  "No Preference",
  "Window",
  "Aisle",
  "Right",
  "Left",
  "Front",
  "Tail",
];

const MEAL_PREFERENCE = [
  { value: "No Preference", label: "No Preference" },
  { value: "KSML", label: "Kosher" },
  { value: "MOML", label: "Halal" },
  { value: "LFML", label: "Low cholesterol" },
  { value: "LSML", label: "Low Sodium" },
  { value: "VGML", label: "Vegan" },
  { value: "VLML", label: "Vegetarian" },
  { value: "BBML", label: "Baby food" },
  { value: "CHML", label: "Child" },
  { value: "DBML", label: "Diabetic" },
  { value: "GFML", label: "Gluten free" },
  { value: "HNML", label: "Hindu" },
  { value: "SFML", label: "Sea Food" },
];

const FREQUENT_FLYER_PROGRAM = [
  {
    value: "-- Select  Frequent Flyer Type --",
    label: "-- Select  Frequent Flyer Type --",
  },
  { value: "EI", label: "Aer Lingus TAB®" },
  { value: "ML", label: "Aero Costa Rica Aero Pass" },
  { value: "AR", label: "Aerolîneas Argentinas Plus" },
  { value: "RK", label: "Air Afrique Fidelite" },
  { value: "UU", label: "Air Austral Capricornne" },
  { value: "AC", label: "Air Canada Aeroplan®" },
  { value: "CA", label: "Air China Companion" },
  { value: "AF", label: "Air France - KLM Flying Blue" },
  { value: "AI", label: "Air India Flying Returns" },
  { value: "MK", label: "Air Mauritius MK Plus" },
  { value: "NZ", label: "Air New Zealand Air Points" },
  { value: "AS", label: "Alaska Airlines Mileage Plan" },
  { value: "AZ", label: "Alitalia Club MilleMiglia" },
  { value: "NH", label: "All Nippon Airways ANA Mileage Club" },
  { value: "AQ", label: "Aloha Airlines AlohaPass" },
  { value: "HP", label: "America West Flightfund" },
  { value: "AA", label: "American Airlines AAdvantage®" },
  { value: "OS", label: "Austrian Airlines Qualiflyer" },
  { value: "BW", label: "BWIA Frequent Flyer" },
  { value: "BA", label: "British Airways Executive Club" },
  { value: "BD", label: "British Midland Diamond Club" },
  { value: "CP", label: "Canadian Airlines Canadian Plus" },
  { value: "CX", label: "Cathay Pacific Asia Miles" },
  { value: "CX", label: "Cathay Pacific Marco Polo Club" },
  { value: "CI", label: "China Airlines Dynasty Flyer" },
  { value: "CZ", label: "China Southern Airlines Sky Pearl Club" },
  { value: "CO", label: "Continental Airlines OnePass" },
  { value: "OU", label: "Croatia Airlines Frequent Flyer Club" },
  { value: "OK", label: "Czech Airline OK Plus" },
  { value: "DL", label: "Delta Skymiles" },
  { value: "BR", label: "EVA Evergreen Club" },
  { value: "LY", label: "El Al Frequent Flyer" },
  { value: "EK", label: "Emirates Skywards" },
  { value: "EW", label: "Eurowings Flying Dutchman" },
  { value: "AY", label: "Finnair Plus" },
  { value: "GF", label: "Gulfair Falcon" },
  { value: "HA", label: "Hawaiian Airlines HawaiianMiles" },
  { value: "IB", label: "Iberia Plus" },
  { value: "JL", label: "JAL Mileage Bank" },
  { value: "KL", label: "KLM - Air France Flying Blue" },
  { value: "KE", label: "Korean Air SkyPASS" },
  { value: "LO", label: "LOT Polish Airlines Voyager" },
  { value: "LH", label: "Lufthansa Miles and More" },
  { value: "MH", label: "Malaysia Airlines Enrich" },
  { value: "MA", label: "Malev Duna Club" },
  { value: "MX", label: "Mexicana Frecuenta" },
  { value: "ME", label: "Middle East Airlines" },
  { value: "YX", label: "Midwest Express Frequent Flyer" },
  { value: "NW", label: "Northwest Airlines WorldPerks®" },
  { value: "OA", label: "Olympic Airways Icarus" },
  { value: "PR", label: "Philippine Airlines Mabuhay Club and PALSmiles" },
  { value: "QF", label: "Qantas Frequent Flyer" },
  { value: "QR", label: "Qatar Airways" },
  { value: "AT", label: "Royal Air Maroc Safar Flyer" },
  { value: "Q3", label: "SAS EuroBonus" },
  { value: "SN", label: "SN Brussels Airlines" },
  { value: "S2", label: "Sahara Airlines Frequent Flier Programme" },
  { value: "SV", label: "Saudi Arabian Airlines Alfursan" },
  { value: "SQ", label: "Singapore Airlines KrisFlyer" },
  { value: "SA", label: "South African Airways Voyager" },
  { value: "UL", label: "Sri Lankan Airlines Skywards" },
  { value: "BV", label: "Sunair AIRewards" },
  { value: "SR", label: "Swiss Travel Club" },
  { value: "TP", label: "TAP Air Portugal Qualiflyer" },
  { value: "TW", label: "TWA Aviators" },
  { value: "TG", label: "Thai Airways Royal Orchid Plus" },
  { value: "TU", label: "Tunisair Carte Fidelys" },
  { value: "US", label: "US Airways Dividend Miles" },
  { value: "PS", label: "Ukraine International Panorama" },
  { value: "UA", label: "United Airlines Mileage Plus®" },
  { value: "VG", label: "VLM Frequent Flyer Programme" },
  { value: "RG", label: "Varig Smiles" },
  { value: "VS", label: "Virgin Atlantic Flying Club®" },
  { value: "MF", label: "Xiamen Airlines Frequent Flyer Program" },
];

const ASSISTANCE_OPTIONS = ["No Preference", "Deaf", "Blind", "Wheelchair"];

export {
  InitialPrice,
  InitialFilters,
  InitialStops,
  InitialAirlineName,
  InitialFlights,
  TIMINGS,
  NAMES,
  CABINS,
  CABIN_OPTIONS,
  HALT_DURATIONS,
  DEFAULT_UK_ORIGIN,
  USA_CURRENCY,
  UK_CURRENCY,
  EU_CURRENCY,
  SEAT_PREFERENCE,
  MEAL_PREFERENCE,
  FREQUENT_FLYER_PROGRAM,
  ASSISTANCE_OPTIONS,
  OPTIONAL_FIELDS,
};
